import { Routes } from '@angular/router';
import { FactoringComponent } from './factoring/factoring.component';
import { ReviewsComponent } from './reviews/reviews.component';
import { ClientsComponent } from './clients/clients.component';
import { InternalUsersComponent } from './internal-users/internal-users.component';
import { FilesClientsComponent } from './files-clients/files-clients.component';
import { MinutesComponent } from './files-clients/sub-page/minutes/minutes.component';
import { PdfComponent } from './files-clients/sub-page/components/pdf/pdf.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { QrMinuteComponent } from './files-clients/sub-page/components/qr-minute/qr-minute.component';
import { ViewMinutesComponent } from './view-minutes/view-minutes.component';
import { WarrantiesComponent } from './warranties/warranties.component';
import { DebtorsFavoriteComponent } from './clients/components/debtors-favorite/debtors-favorite.component';
import { DebtorBlackListComponent } from './clients/components/debtor-black-list/debtor-black-list.component';
import { FutureFeatureComponent } from './future-feature/future-feature.component';
import { FormulaViewComponent } from './formula-view/formula-view.component';
import { AllDebtorsComponent } from './clients/components/all-debtors/all-debtors.component';
import { CompanysUnExecutiveComponent } from './clients/components/companys-un-executive/companys-un-executive.component';
import { FormulaCompanyDetailComponent } from './formula-view/formula-company-detail/formula-company-detail.component';
import { NewMinuteComponent } from './clients/components/new-minute/new-minute.component';
import { authGuard, authGuardClient } from '../authentication/guards/auth.guard';
import { NotFound404Component } from './not-found404/not-found404.component';
import { ClientInfoComponent } from './clients/client-info/client-info.component';
import { DashboardClientsComponent } from './dashboard-clients/dashboard-clients.component';
import { FactoringOpportunitiesComponent } from './factoring-opportunities/factoring-opportunities.component';
import { Permissions } from 'src/app/common/permissions';
import { Unauthorized401Component } from './unauthorized401/unauthorized401.component';
import { ViewDealsEvaluationsComponent } from './warranties/view-deals-evaluations/view-deals-evaluations.component';
import { ViewDealsSimulationsComponent } from './warranties/view-deals-simulations/view-deals-simulations.component';

export const DashboardsRoutes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        canActivate: [authGuard],
        component: FactoringComponent,
        data: {
          permission: Permissions.ViewAllClients,
          urls: [
            { title: 'Dashboard', url: '/dashboards/clients' },
            { title: 'All Clients' },
          ],
        },
      },
      {
        path: 'clients',
        canActivate: [authGuard],
        component: FactoringComponent,
        data: {
          permission: Permissions.ViewAllClients,
          urls: [
            { title: 'Dashboard', url: '/dashboards/clients' },
            { title: 'All Clients' },
          ],
        },
      },
      {
        path: 'reviews',
        component: ReviewsComponent,
        data: {
          urls: [
            { title: 'Dashboard', url: '/dashboards/reviews' },
            { title: 'Revisiones' },
          ],
        },
      },
      {
        path: 'cliensOutEjecutive',
        component: CompanysUnExecutiveComponent,
        data: {
          urls: [
            { title: 'Dashboard', url: '/dashboards/cliensOutEjecutive' },
            { title: 'Clientes' },
          ],
        }
      },
      {
        path: 'warranties',
        component: WarrantiesComponent,
        data: {
          urls: [
            { title: 'Dashboard', url: '/dashboards/warranties' },
            { title: 'Garantías' }
          ]
        }
      },
      {
        path: 'dealsEvaluation',
        component: ViewDealsEvaluationsComponent,
        data: {
          urls: [
            { title: 'Deals', url: '/dashboards/dealsEvaluation' }
          ]
        }
      },
      {
        path: 'simulations',
        component: ViewDealsSimulationsComponent,
        data: {
          Permissions: Permissions.ManageSalesQuotes,
          urls: [
            { title: 'Cotizacion', url: '/dashboards/simulations' }
          ]
        }
      },
      {
        path: 'simulations/:id',
        component: ViewDealsSimulationsComponent,
        data: {
          Permissions: Permissions.ManageSalesQuotes,
          urls: [
            { title: 'Cotizacion', url: '/dashboards/simulations' }
          ]
        }
      },
      {
        path: 'internal-user',
        component: InternalUsersComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/internal-user' }],
        },
      },
      {
        path: 'portfolio',
        component: PortfolioComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/portoflio' }],
        },
      },
      {
        path: 'allDebtors',
        component: AllDebtorsComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/allDebtors' }],
        },
      },
      {
        path: 'debtors-Favorites',
        component: DebtorsFavoriteComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/debtors-Favorites' }],
        },
      },
      {
        path: 'debtors-BlackList',
        component: DebtorBlackListComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/debtors-BlackList' }],
        },
      },
      {
        path: 'files-clients',
        component: FilesClientsComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/files-clients' }],
        },
      },
      {
        path: 'old-minute',
        component: MinutesComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/minutes' }],
        },
      },
      {
        path: 'minute',
        component: NewMinuteComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/newMinutes' }],
        },
      },
      {
        path: 'view-minutes',
        component: ViewMinutesComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/view-minutes' }],
        },
      },
      {
        path: 'pdf',
        component: PdfComponent,
        data: {
          urls: [{ title: 'Dashboard', url: '/dashboards/pdf' }],
        },
      },
      {
        path: 'minuteQR',
        component: QrMinuteComponent,
        data: {
          urls: [{ title: 'MinuteQR', url: '/dashboards/minuteQR' }],
        },
      },
      {
        path: 'proximamente',
        component: FutureFeatureComponent,
        data: {
          urls: [{ title: 'proximamente', url: '/dashboards/proximamente' }],
        },
      },
      {
        path: 'proximamente2',
        component: FutureFeatureComponent,
        data: {
          urls: [{ title: 'proximamente2', url: '/dashboards/proximamente2' }],
        },
      },
      {
        path: 'factoring',
        component: FormulaViewComponent,
        data: {
          urls:[
            {title: 'Formula', url: '/dashboards/factoring'}
          ]
        }
      },
      {
        path: 'factoring/:id',
        component: FormulaCompanyDetailComponent,
        data: {
          urls: [
            { title: 'Formula', url: '/dashboards/factoring'}
          ]
        }
      },
      {
        path: 'factoring-opportunities',
        component: FactoringOpportunitiesComponent,
        data: {
          urls:[
            {title: 'Oportunidades', url: '/dashboards/factoring-opportunities'}
          ]
        }
      }

    ],
  },
  {
    path: 'cliente',
    canActivate: [authGuardClient],
    children: [
      {
        path: 'companies',
        component: ClientsComponent,
        data: {
          urls: [
            { title: 'Dashboard', url: '/dashboards/cliente/companies' },
            { title: 'Clientes' },
          ],
        }
      },
      {
        path: 'dashboard',
        component: DashboardClientsComponent,
        data: {
          urls: [
            { title: 'Dashboard', url: '/dashboards/cliente/dashboard' },
            { title: 'Clientes' },
          ],
        }
      },
      {
        path: 'meInfo',
        component: ClientInfoComponent,
        data: {
          urls: [
            { title: 'Dashboard', url: '/dashboards/cliente/meInfo' },
            { title: 'Clientes' },
          ],
        }
      },
    ]
  },
  {
    path: 'notFound',
    component: NotFound404Component,
    data: {
      urls: [
        { title: 'Dashboard', url: '/dashboards/notFound' },
        { title: 'No encontrado' },
      ],
    }
  },
  {
    path: 'unauthorized',
    component: Unauthorized401Component,
    data: {
      urls: [
        { title: 'Dashboard', url: '/dashboards/unauthorized' },
        { title: 'No Autorizado' },
      ],
    }
  },
    
];
